import { render } from "./PaymentTable.vue?vue&type=template&id=757d768c&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=ts"
export * from "./PaymentTable.vue?vue&type=script&lang=ts"

import "./PaymentTable.vue?vue&type=style&index=0&id=757d768c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-757d768c"

export default script